import { get, put } from './requests.js'

export const loadEntity = async (entity, id) => get([entity, id])

export const loadSchema = async (entity) => get([entity, 'schema'])

export const updateEntity = async (entity, id, data) => put([entity, id], {}, data)

export const uploadS3 = async (entity) => put([entity, 'distribute'])

export const getContentRule = (id) => get(['content-rules', id])

export const updateContentRule = async (id, data) => put(['content-rules', id], {}, data)

export const getContentRuleChangeRequest = (id) => get(['content_rule_change_requests', id])

export const updateContentRuleChangeRequest = async (id, data) =>
  put(['content_rule_change_requests', id], {}, data)
